module.exports = __webpack_public_path__ + "static/media/logo-dark.f15cdf24.png";